<template>
<v-dialog
  :value="openModal"
  persistent
  @close="closeModal"
  max-width="800"
  :content-class="'ModalCreateEducation'"

>
  <v-card class="ModalCreateEducation__card d-flex flex-column px-6 py-4">
    <div class="ModalCreateEducation__close d-flex justify-end">
      <v-btn
        small
        @click="closeModal">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="ModalCreateEducation__title">
      <span v-if="isUpdate">Редактировать обучающий материал</span>
      <span v-else>Добавить обучающий материал</span>

    </div>
    <div class="ModalCreateEducation__body d-flex flex-column">
      <div>
        <p>Выберите категорию, в которую будет добавлен материал</p>
        <v-select
          v-model="fieldCategory"
          :items="categories"
          label="Выберите раздел"
          :item-text="(item) => item.title"
          item-value="value"
          outlined
          return-object
        />
        <div class="text-error pt-1" >
          {{getFieldError('category')}}
        </div>
      </div>
      <div
        v-if="!isPreview"
        class="d-flex flex-column gap-4"
      >
        <div >
          <p>Заголовок</p>
          <v-textarea
            v-model="fieldTitle"
            :placeholder="'Введите название заголовка'"
            :value="fieldTitle"
            :dense="true"
            :outlined="true"
            :hide-details="true"
          />
          <div class="text-error pt-1">
            {{getFieldError('title')}}
          </div>
        </div>
        <div class="w-100">
          <p>Текст</p>
          <v-textarea
            v-model="fieldBody"
            :class="'full text-pre-wrap'"
            :placeholder="'Добавьте текст'"
            :value="fieldBody"
            :dense="true"
            :outlined="true"
            :hide-details="true"
          />
          <div class="text-error pt-1">
            {{getFieldError('body')}}
          </div>
        </div>
        <div class="">
          <p>Видео</p>
          <v-textarea
            v-model="fieldVideo"
            :placeholder="'Добавьте ссылку на видео'"
            :value="fieldVideo"
            :dense="true"
            :outlined="true"
            :hide-details="true"
          />
          <div class="text-error pt-1">
            {{getFieldError('video')}}
          </div>
        </div>
      </div>
      <div
        v-if="isPreview"
        class="d-flex flex-column gap-4"
      >
        <div class="d-flex justify-center">
          <iframe
            v-if="fieldVideo"
            height="290px"
            width="100%"
            class="video-frame"
            :src="fieldVideo"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          >
          </iframe>
        </div>
        <div class="w-100 text-pre-wrap">{{ fieldBody }}</div>
      </div>
    </div>
    <div class="ModalCreateEducation__btn-group">
      <div v-if="isPreview">
        <v-btn
          class="mr-3 _w-100"
          outlined
          color="primary"
          @click="returnToEdit"
        >
          Назад
        </v-btn>
      </div>
      <div v-if="!isPreview">
        <v-btn
          class="mr-3 _w-100"
          outlined
          color="primary"
          @click="cancel"
        >
          Отменить
        </v-btn>
      </div>
      <div v-if="isPreview">
        <v-btn
          class="_w-100"
          color="primary"
          @click="acceptButtonPreview"
        >
          <span v-if="updateItem && updateItem.id">Обновить</span>
          <span v-else>Создать</span>
        </v-btn>
      </div>
      <div v-if="(isUpdate || isCreate)">
        <v-btn
          class="_w-100"
          color="primary"
          @click="showPreview"
        >
          Просмотреть
        </v-btn>
      </div>
    </div>
  </v-card>
</v-dialog>
</template>

<script>

import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { customCardValidators } from '@/common/validationHelpers';

/**
 * Компонент: ModalCreateEducation
 * Описание:
 */
export default {
  name: 'ModalCreateEducation',

  components: { },

  props: {
    openModal: {
      type: Boolean,
      default: false
    },
    uploadFile: {
      type: Object,
      default: () => ({
        isUpload: false,
        image: null,
      }),
    },
    updateItem: {
      type: [Object, null],
      default: () => null
    },
    isUpdate: {
      type: Boolean,
      default: false
    },
    isCreate: {
      type: Boolean,
      default: false
    },
    isPreview: {
      type: Boolean,
      default: false
    },
  },
  emits: ['closeModal', 'upload:file', 'createEducation', 'updateEducation', 'showPreview', 'returnToEdit'],

  validations() {
    const rules = {
      category: {
        required,
      },
      title: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(255),
      },
      body: {
        required,
        minLength: minLength(5),
      },
      video: {
        linkValidator: customCardValidators.validatorLinks()
      },
      // image: {
      //   required,
      //   maxSize: imageValidators.maxSize(5),
      //   format: imageValidators.format(['jpg', 'png', 'jpeg', 'webp']),
      // }
    };
    return {
      formValues: rules
    };
  },

  data() {
    const fieldCategory = null;
    const fieldTitle = '';
    const fieldBody = '';
    const fieldVideo = '';
    const fieldImage = null;
    const fieldImageBase64 = null;
    const loadingImage = false;
    const styleUploadBox = {
      height: '188px',
      margin: 0
    };
    const imageError = null;
    const formValues = {};

    return {
      fieldCategory,
      fieldBody,
      fieldTitle,
      fieldVideo,
      fieldImage,
      styleUploadBox,
      loadingImage,
      fieldImageBase64,
      imageError,
      formValues,
    };
  },

  computed: {
    ...mapGetters({
      categories: 'education/Education/getAllEducationCategories'
    }),

  },

  watch: {
    fieldCategory(val) {
      this.$set(this.formValues, 'category', val);
    },
    fieldTitle(val) {
      this.$set(this.formValues, 'title', val);
    },
    fieldBody(val) {
      this.$set(this.formValues, 'body', val);
    },
    fieldImage(val) {
      this.$set(this.formValues, 'image', val);
    },
    fieldVideo(val) {
      this.$set(this.formValues, 'video', val);
    },
    // isUpdate(val) {
    //   console.log(val);
    //   if (val) {
    //     this.fillField();
    //   }
    // },
    openModal(val) {
      if (!val) {
        this.closeModal();
      }
      if (this.isUpdate && val) {
        this.fillField();
      }
    },

  },

  created() {
  },

  mounted() {
    if (this.isUpdate) {
      this.fillField();
    }
  },

  beforeDestroy() {
  },

  methods: {
    clickSubmit(file) {
      this.$emit('upload:file', file);
    },
    okClicked() {

    },
    cancel() {
      this.closeModal();
      this.fieldCategory = null;
      this.fieldTitle = '';
      this.fieldBody = '';
      this.fieldVideo = '';
      this.fieldImage = null;
      this.fieldImageBase64 = null;
    },
    showError(error) {
      this.imageError = error;
    },
    readFileAsDataURL(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);
        reader.readAsDataURL(file);
      });
    },
    deleteImage() {
      this.fieldImageBase64 = null;
      this.fieldImage = null;
    },
    validateForm() {
      if (this.$v.formValues.category) {
        this.$v.formValues.category.$touch();
      }
      if (this.$v.formValues.title) {
        this.$v.formValues.title.$touch();
      }
      if (this.$v.formValues.body) {
        this.$v.formValues.body.$touch();
      }
      if (this.$v.formValues.video) {
        this.$v.formValues.video.$touch();
      }
      // if (this.$v.formValues.image) {
      //   this.$v.formValues.image.$touch();
      // }
    },
    getFieldError(fieldName) {
      const validator = this.$v.formValues[fieldName];
      if (!validator || !validator.$error) return '';
      if (validator.required === false) {
        return 'Это поле обязательно';
      }
      if (validator.minLength === false) {
        return 'Минимум 5 символов';
      }
      if (validator.maxLength === false) {
        return 'Максимум 255 символов';
      }
      if (validator.maxSize === false) {
        return 'Макс. размер  5 МБ';
      }
      if (validator.format === false) {
        return 'Не допустимый формат';
      }
      if (validator.linkValidator === false) {
        return 'Введите корректную ссылку';
      }
      return 'Ошибка валидации';
    },
    touchField(field) {
      const fieldName = `field_${field.field}`;
      if (this.$v.formValues[fieldName]) {
        this.$v.formValues[fieldName].$touch();
      }
    },
    closeModal() {
      this.$emit('closeModal');
      this.fieldCategory = null;
      this.fieldTitle = '';
      this.fieldBody = '';
      this.fieldVideo = '';
    },
    returnToEdit() {
      this.$emit('returnToEdit');
    },
    showPreview() {
      this.validateForm();
      if (this.$v.$invalid) {
        Vue.prototype.$toast.error('Форма заполнена некорректно', '', { position: 'bottomCenter' });
        return;
      }
      this.$emit('showPreview');
    },
    // renderImage
    async renderImageBase64(image) {
      if (!image || !image.type.match('image.*')) {
        this.showError('Формат изображения неверный');
        return null;
      }
      try {
        return await this.readFileAsDataURL(image);
      } catch (error) {
        this.showError(`Ошибка чтения файла ${error}`);
        return null;
      }
    },
    async uploadImage(file) {
      this.loadingImage = true;
      const base64Image = await this.readFileAsDataURL(file);
      if (base64Image) {
        this.fieldImage = file;
        this.fieldImageBase64 = base64Image;
      }

      this.loadingImage = false;
    },
    acceptButtonPreview() {
      if (this.updateItem && this.updateItem.id) {
        return this.createEducation(true);
      }
      return this.createEducation(false);
    },
    async urlToFile(imageUrl, fileName = null) {
      try {
        const response = await fetch(imageUrl);
        if (!response.ok) {
          throw new Error(`Ошибка загрузки: ${response.status}`);
        }
        const blob = await response.blob();
        let finalFileName = fileName;
        if (!finalFileName) {
          const urlObj = new URL(imageUrl);
          const pathParts = urlObj.pathname.split('/');
          finalFileName = pathParts[pathParts.length - 1] || 'image';
        }

        let mimeType = blob.type;

        if (mimeType === 'binary/octet-stream'
          || mimeType === 'application/octet-stream'
          || !mimeType
          || mimeType === '') {
          let extension = '';

          if (finalFileName.includes('.')) {
            extension = finalFileName.split('.').pop().toLowerCase();
          } else {
            const urlExtension = imageUrl.split('.').pop().split('?')[0].toLowerCase();
            extension = urlExtension;
            finalFileName = `image.${extension}`;
          }
          const mimeMap = {
            jpg: 'image/jpeg',
            jpeg: 'image/jpeg',
            png: 'image/png',
            gif: 'image/gif',
            webp: 'image/webp',
            svg: 'image/svg+xml',
            bmp: 'image/bmp',
            ico: 'image/x-icon',
            tiff: 'image/tiff',
            tif: 'image/tiff',
            pdf: 'application/pdf',
            doc: 'application/msword',
            docx: 'application/msword',
          };

          mimeType = mimeMap[extension] || 'image/jpeg';
        }

        const file = new File([blob], finalFileName, {
          type: mimeType,
          lastModified: Date.now()
        });
        return file;
      } catch (error) {
        throw new Error(error);
      }
    },
    async fillField() {
      if (this.isUpdate) {
        console.log(this.updateItem);
        this.fieldTitle = this.updateItem.title;
        this.fieldBody = this.updateItem.text;
        this.fieldVideo = this.updateItem.video_url;
        this.fieldCategory = this.categories.find(item => item.value === this.updateItem.category);
        if (this.updateItem?.image_url) {
          const file = await this.urlToFile(this.updateItem.image_url);
          if (file) {
            this.fieldImage = file;
            this.fieldImageBase64 = this.updateItem.image_url;
          }
        }
      }
    },
    async createEducation(update = false) {
      const data = {
        // "notes": "string"
        category: this.fieldCategory.value,
        title: this.fieldTitle,
        text: this.fieldBody,
        video_url: this.fieldVideo,
        is_active: false,
      };
      this.validateForm();
      if (this.$v.$invalid) {
        Vue.prototype.$toast.error('Форма заполнена некорректно', '', { position: 'bottomCenter' });
        return;
      }
      if (update) {
        data.id = this.updateItem.id;
        this.$emit('updateEducation', data);
        this.closeModal();
      } else {
        await this.$emit('createEducation', data);
      }
    },

  },
};
</script>

<style scoped lang="scss">
.ModalCreateEducation {
  &__card {
    border-radius: 20px !important;
    box-shadow: none !important;
    gap: 24px;
  }

  &__close {
    & > button {
      box-shadow: none !important;
      background: transparent;
    }
  }

  &__title {
    font-size: 22px;
    color: var(--color-blue-500);
    font-weight: 600;
  }

  &__btn-group {
    display: flex;
    justify-content: flex-end;
  }

  &__body{
    & .v-select {

    }
    & .v-textarea {
      ::v-deep .v-input__control{
        border-radius: 8px;
        border: 1px solid var(--color-grey-200);
      }
      &.full::v-deep textarea{
        height: 140px;
        border-radius: 20px;
        padding-left: 8px;
      }
      ::v-deep textarea{
        height: 40px;
        border-radius: 20px;
        padding-left: 8px;
      }
    }
    & .image-field .error-image{
      padding: 4px;
      border-radius: 10px;
      outline: 2px dashed var(--v-error-base);
      color:  var(--v-error-base);
    }
  }

}
</style>
